/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerOffersResponse as ModelsCustomerCustomerOffersResponse } from '../../models/Models/Customer/customer-offers-response';

export interface V4CustomersMeOffersGet$Xml$Params {
}

export function v4CustomersMeOffersGet$Xml(http: HttpClient, rootUrl: string, params?: V4CustomersMeOffersGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOffersResponse>> {
  const rb = new RequestBuilder(rootUrl, v4CustomersMeOffersGet$Xml.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsCustomerCustomerOffersResponse>;
    })
  );
}

v4CustomersMeOffersGet$Xml.PATH = '/v4/customers/me/offers';
